import { render, staticRenderFns } from "./ReceptionDate.vue?vue&type=template&id=73cc0af6&scoped=true"
import script from "./ReceptionDate.vue?vue&type=script&lang=js"
export * from "./ReceptionDate.vue?vue&type=script&lang=js"
import style0 from "./ReceptionDate.vue?vue&type=style&index=0&id=73cc0af6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cc0af6",
  null
  
)

export default component.exports